import { useState, useEffect, useContext } from 'react'

import * as auth from '../../../api/auth/auth'
import * as Yup from 'yup'

import * as S from './styles'
import { FormGroup } from '../../Form/styles'
import TextField from '../../TextField'
import {
  addressNumber,
  cepMask,
  noMask,
  noSpecialChars
} from '../../FormPF/masks'
import { useToast } from '../../../hooks/toast'

import defaultOptions from '../../../api/defaultoption'

import ceps from '../../../api/ceps'
import { getFaturamentoUF } from '../../../pages/MeusEnderecos/validatePJ'
import clientes from '../../../api/clientes'
import { capitalizePhrase } from '../../../utils/utils'
import { validatePJData } from '../../../utils/validateReceitaFederal'
import { validateReceitaError } from '../../DadosCadastroPJ/fieldValidator'
import { UserContext } from '../../../contexts/UserContext'
import { useMutation } from 'react-query'
import { editAddressById } from '../../../hooks/address/useAddresses'
import { queryClient } from '../../../services/queryClient'

const EditAddressForm = ({ address, setCurrent, cardId }) => {
  const { addToast } = useToast()
  const { user, setAddress, setLoading } = useContext(UserContext)

  const { mutateAsync, error } = useMutation(editAddressById, {
    onSuccess: (data, variables) => {
      addToast({
        type: 'success',
        title: `Endereço editado!`
      })

      queryClient.invalidateQueries('enderecos')
      setCurrent(1)
    },
    onError: () => {
      addToast({
        type: 'error',
        title: 'Problema ao editar endereço. Tente novamente',
        description: `${error}`
      })
    }
  })

  const [inputErrors, setInputErrors] = useState({})

  const [isCepUnico, setIsCepUnico] = useState(false)
  const [receitaFederalError, setReceitaFederalError] = useState({
    cep: { status: false, message: '' },
    numero: { status: false, message: '' },
    uf: { status: false, message: '' },
    cnpj: { status: false, message: '' },
    inscricaoEstadual: { status: false, message: '' },
    inscricaoMunicipal: { status: false, message: '' },
    nomeFantasia: { status: false, message: '' },
    razaoSocial: { status: false, message: '' }
  })

  const [isInscEstValid, setIsInscEstValid] = useState({
    valid: false,
    message: '',
    showToaster: false
  })

  const [values, setValues] = useState({
    id: cardId,
    padrao: false,
    tipoEndereco: 'E',
    apelido: '',
    bairro: '',
    cep: '',
    cidade: '',
    complemento: '',
    logradouro: '',
    numero: '',
    pontoReferencia: '',
    tipoLogradouro: '',
    uf: ''
  })

  const faturamentoUF = getFaturamentoUF(address)

  const handleReceitaFederalErrorChange = (value, field, message) => {
    setReceitaFederalError((prev) => ({
      ...prev,
      [field]: { status: value, message: message }
    }))
  }

  const handleEditAddress = async () => {
    const item = address.find((element) => element.id === cardId)
    setValues(item)
  }

  useEffect(() => {
    handleEditAddress()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleChange = (e) => {
    const { name, value } = e.target
    setValues({
      ...values,
      [name]:
        name === 'apelido'
          ? noSpecialChars(value.trimStart())
          : value.trimStart()
    })

    setInputErrors({
      ...inputErrors,
      [name]: ''
    })

    if (typeof value === 'string') {
      setReceitaFederalError({
        cep: { status: false, message: '' },
        numero: { status: false, message: '' },
        uf: { status: false, message: '' },
        cnpj: { status: false, message: '' },
        inscricaoEstadual: { status: false, message: '' },
        inscricaoMunicipal: { status: false, message: '' },
        nomeFantasia: { status: false, message: '' },
        razaoSocial: { status: false, message: '' }
      })
    }
  }

  const handleCEPChange = (e) => {
    const { name, value } = e.target
    setValues({
      ...values,
      [name]: cepMask(value)
    })

    setInputErrors({
      ...inputErrors,
      [name]: ''
    })

    if (typeof value === 'string') {
      setReceitaFederalError((prev) => ({
        ...prev,
        cep: false
      }))
    }
  }

  const handleNumberChange = (e) => {
    const { name, value } = e.target
    setValues({
      ...values,
      [name]: addressNumber(value)
    })

    setInputErrors({
      ...inputErrors,
      [name]: ''
    })

    if (typeof value === 'string') {
      setReceitaFederalError((prev) => ({
        ...prev,
        numero: false
      }))
    }
  }

  const handleBlur = (e) => {
    const { name, value } = e.target

    setValues({
      ...values,
      [name]: value.trimEnd().replace(/  +/g, ' ')
    })
  }

  const validateInscEstadual = async (inscricaoEstadual, cepUF) => {
    const data = await clientes
      .getInscricaoEstadual(inscricaoEstadual, cepUF)
      .then((res) => res.text())

    if (data.length === 0) {
      setIsInscEstValid({
        valid: true,
        message: '',
        showToaster: true
      })
      return true
    } else {
      // console.log('INVÁLIDO', data)
      setIsInscEstValid({
        valid: false,
        message: data,
        showToaster: true
      })

      return false
    }
  }

  const isPromise = (obj) => {
    let result = obj instanceof Promise || (obj && typeof obj.then === 'function');
    return result;
  }

  const isNewAddressValid = async (uf) => {
    let faturamentoUFLocal = null

    if (isPromise(faturamentoUF)){
      faturamentoUF.then(resultado => {
        faturamentoUFLocal = resultado;
        if (user.inscricaoEstadual === 'ISENTO') {
          // console.log('ISENTO')
          if (values.tipoEndereco === 'C') {
            // console.log('permitir pois é edição do faturamento')
            return true
          } else if (uf === faturamentoUFLocal) {
            // console.log('PERMITIR CASO UF ENT = UF FAT')
            return true
          } else if (uf !== faturamentoUFLocal) {
            // console.log('Bloquear UF diferente do Faturamento')
            addToast({
              type: 'error',
              title:
                'ATENÇÃO: Não é possível cadastrar endereço de entrega com Estado diferente do endereço de faturamento'
            })
            return false
          } else {
            // console.log('não sei')
            return false
          }
        } else {
          // console.log('TEM INCRIÇÃO')
          if (values.tipoEndereco === 'C') {
            // console.log('permitir pois é edição do faturamento')
            return true
          } else if (uf === faturamentoUFLocal) {
            // console.log('PERMITIR CASO UF ENT = UF FAT')
            return true
          } else if (uf !== faturamentoUFLocal) {
            // console.log('Bloquear UF diferente do Faturamento')
            addToast({
              type: 'error',
              title:
                'ATENÇÃO: Não é possível cadastrar endereço de entrega com Estado diferente do endereço de faturamento'
            })
            return false
          } else if (faturamentoUFLocal !== 'SP' || faturamentoUFLocal !== 'RJ') {
            // console.log('Bloquear FAT diferente SP ou RJ')
            addToast({
              type: 'error',
              title:
                'ATENÇÃO: Não é possível cadastrar endereço de entrega com Estado diferente do endereço de faturamento'
            })
            return false
          } else {
            // console.log('não sei')
            return false
          }
        }

      }).catch(erro => {
        // Trate erros, caso ocorram
        console.error(erro);
      });
    }

   
  }

  async function onBlurCep() {
    // checkCEPUnicoBlur(values.cep)

    if (noMask(values.cep).length === 8) {
      setLoading(true)
      const data = await ceps
        .getAddress(noMask(values.cep), defaultOptions)
        .then((res) => {
          if (res.ok) {
            setLoading(false)

            return res.json()
          } else if (!res.body) {
            addToast({
              title: 'Cep não encontrado',
              type: 'error'
            })
          }
        })
        .catch(() => {
          setLoading(false)

          addToast({
            type: 'error',
            title: 'Problema ao buscar CEP',
            description: `O CEP informado não foi encontrado`
          })
          setValues({
            ...values,
            bairro: '',
            cidade: '',
            complemento: '',
            logradouro: '',
            tipoLogradouro: '',
            uf: ''
          })
        })

      if (data) {
        const { bairro, cidade, complemento, endereco, tipoLogradouro, uf } =
          data

        // console.log('Editar?', isNewAddressValid(uf))
        validateInscEstadual(user.inscricaoEstadual, uf)

        if (endereco.trim() === '') {
          setIsCepUnico(true)
        } else {
          setIsCepUnico(false)
        }

        if (!auth.isPF() && isNewAddressValid(uf) === true) {
          setValues({
            ...values,
            bairro: bairro,
            cidade: cidade,
            // complemento: complemento,
            // logradouro:
            //   endereco === ''
            //     ? `${tipoLogradouro}${endereco}`
            //     : `${tipoLogradouro} ${endereco}`,
            logradouro: endereco,
            tipoLogradouro: tipoLogradouro,
            uf: uf
          })
        } else if (!auth.isPF() && isNewAddressValid(uf) === false) {
          setValues({
            ...values,
            bairro: '',
            cidade: '',
            complemento: '',
            logradouro: '',
            tipoLogradouro: '',
            uf: ''
          })
        } else {
          setValues({
            ...values,
            bairro: bairro,
            cidade: cidade,
            // complemento: complemento,
            // logradouro:
            //   endereco === ''
            //     ? `${tipoLogradouro}${endereco}`
            //     : `${tipoLogradouro} ${endereco}`,
            logradouro: endereco,
            tipoLogradouro: tipoLogradouro,
            uf: uf
          })
        }
      }
    }

    if ((noMask(values.cep).length < 8) & (noMask(values.cep).length > 0)) {
      addToast({
        type: 'error',
        title: 'CEP inválido',
        description: `O CEP deve conter 8 dígitos`
      })
      setValues({
        ...values,
        bairro: '',
        cidade: '',
        complemento: '',
        logradouro: '',
        tipoLogradouro: '',
        uf: ''
      })
    }
  }

  useEffect(() => {
    if (values.cep.length > 9) {
      onBlurCep()
    }
  }, [values.cep])

  async function editAddress(formData) {
    mutateAsync(formData)
  }

  const handleSubmit = async (e) => {
    e.preventDefault()

    setLoading(true)
    const formData = {
      id: cardId,
      padrao: values.padrao,
      tipoEndereco: values.tipoEndereco,
      apelido: values.apelido,
      // tipoLogradouro: values.logradouro.trim().split(' ')[0],
      tipoLogradouro: values.tipoLogradouro,
      logradouro: values.logradouro,
      numero: values.numero,
      complemento: values.complemento || '',
      pontoReferencia: values.pontoReferencia,
      bairro: values.bairro,
      cidade: values.cidade,
      uf: values.uf,
      cep: noMask(values.cep)
    }

    const addressSchema = Yup.object().shape({
      padrao: Yup.bool(),
      tipoEndereco: Yup.string(),
      apelido: Yup.string().required('Apelido Obrigatório'),
      bairro: Yup.string().required('Bairro Obrigatório'),
      cep: Yup.string()
        .required('CEP Obrigatório')
        .min(8, 'CEP deve conter 8 dígitos'),
      cidade: Yup.string()
        .required('Cidade Obrigatório')
        .min(3, 'No mínimo 3 caracteres'),
      complemento: Yup.string(),
      tipoLogradouro: Yup.string(),
      logradouro: Yup.string().required('Logradouro é Obrigatório'),
      numero: Yup.string()
        .min(1, 'No mínimo 1 caractere')
        .required('Número Obrigatório'),
      uf: Yup.string().required('UF Obrigatório')
    })

    const receitaFederalBody = {
      idEtapa: 3,
      cepFaturamento: formData.cep,
      cnpj: user.cnpj,
      inscricaoEstadual: user.inscricaoEstadual,
      inscricaoMunicipal: user.inscricaoMunicipal,
      nomeFantasia: user.nomeFantasia,
      numeroEndereco: formData.numero,
      razaoSocial: user.razaoSocial,
      uf: formData.uf
    }

    const receitaFederalBodyMock = {
      idEtapa: 3,
      cepFaturamento: formData.cep,
      cnpj: '54651716001150',
      inscricaoEstadual: '206192669114',
      inscricaoMunicipal: user.inscricaoMunicipal,
      nomeFantasia: 'GIMBA',
      razaoSocial: 'SUPRICORP SUPRIMENTOS LTDA',
      numeroEndereco: formData.numero,
      uf: formData.uf
    }

    try {
      // console.log(formData)

      await addressSchema.validate(formData, {
        abortEarly: false
      })

      if (
        auth.isPF() === false &&
        formData.tipoEndereco === 'C' &&
        user.validacaoExternaDadosClientePJ === true
      ) {
        const receitaFederalValidation = await validatePJData(
          receitaFederalBody,
          addToast,
          handleReceitaFederalErrorChange
        )

        if (receitaFederalValidation === 'valid') {
          // console.log('EDITAR! PJ Válido')
          editAddress(formData)
          // updateAddress(formData)
        }
      } else {
        editAddress(formData)
        // updateAddress(formData)
      }

      // if (auth.isPF() === true) {
      //   // console.log('EDITAR! É PF')
      //   editAddress(formData)
      //   // updateAddress(formData)
      // }

      // setLoading(false)
    } catch (err) {
      if (err) setLoading(false)

      if (err instanceof Yup.ValidationError) {
        const emptyField = Object.values(err.value).every(
          (value) => value !== ''
        )

        if (!emptyField) {
          addToast({
            type: 'error',
            title: 'Todos os campos devem ser preenchidos'
          })

          const errorArray = err.inner.map((error) => {
            return JSON.parse(
              `{"name": "${error.path}", "message": "${error.message}"}`
            )
          })

          const objeto = errorArray.reduce((acc, d) => {
            acc[d.name] = d.message

            return acc
          }, {})
          setInputErrors(objeto)
        } else {
          setLoading(false)
          err.inner.map((error) => {
            return addToast({
              type: 'error',
              title: `Erro ao editar endereço`,
              description: `${error.message}`
            })
          })
        }
      }
    }
  }

  return (
    <>
      <S.ProfileTitle className="perfil-title">Editar endereço</S.ProfileTitle>
      <S.ProfileBox>
        <form
          method="PUT"
          id="form-endereco"
          // onSubmit={handleSubmit}
        >
          <S.Collunm className="col-4">
            <FormGroup className="form-group required" onBlur={onBlurCep}>
              <label htmlFor="">CEP</label>
              <TextField
                value={cepMask(values.cep)}
                error={
                  inputErrors.cep ||
                  validateReceitaError(
                    receitaFederalError.cep.status,
                    'CEP',
                    receitaFederalError.cep.message
                  )
                }
                type="text"
                maxlength={10}
                name="cep"
                placeholder="Digite o seu CEP"
                required
                onChange={(e) => handleCEPChange(e)}
                // autoFocus
              />
              <a
                href="http://www.buscacep.correios.com.br/sistemas/buscacep/BuscaCepEndereco.cfm"
                className="endereco-link-cep"
                target="_blank"
                rel="noopener noreferrer"
              >
                Não sei meu CEP
              </a>
            </FormGroup>
          </S.Collunm>

          <S.Collunm
            className="col-8"
            style={{ marginBottom: receitaFederalError.cep.status && '22px' }}
          >
            <FormGroup className="form-group required">
              <label htmlFor="">Apelido</label>
              <TextField
                value={values.apelido}
                onBlur={handleBlur}
                error={inputErrors.apelido}
                type="text"
                maxlength={60}
                name="apelido"
                placeholder="Apelido ao endereço"
                required
                className="form-input"
                onChange={(e) => handleChange(e)}
                disabled={values.tipoEndereco === 'C'}
              />
            </FormGroup>
          </S.Collunm>

          <S.Collunm className="col-6">
            <FormGroup className="form-group required">
              <label htmlFor="">Logradouro</label>
              <TextField
                onBlur={handleBlur}
                value={values.logradouro}
                type="text"
                maxlength={60}
                name="logradouro"
                // disabled={!isCepUnico && !disableLogradouro()}
                // disabled={checkLogradouro !== ''}
                disabled={!isCepUnico}
                error={inputErrors.logradouro}
                placeholder="Logradouro"
                required
                className="form-input"
                onChange={(e) => handleChange(e)}
              />
            </FormGroup>
          </S.Collunm>

          <S.Collunm className="col-3">
            <FormGroup className="form-group required" s>
              <label htmlFor="">Número</label>
              <TextField
                value={values.numero}
                error={
                  inputErrors.numero ||
                  validateReceitaError(
                    receitaFederalError.numero.status,
                    'Número',
                    receitaFederalError.numero.message
                  )
                }
                type="text"
                maxlength={8}
                name="numero"
                placeholder="Número "
                required
                className="form-input"
                onChange={(e) => handleNumberChange(e)}
              />
            </FormGroup>
          </S.Collunm>

          <S.Collunm className="col-3">
            <FormGroup className="form-group">
              <label htmlFor="">Complemento</label>
              <TextField
                onBlur={handleBlur}
                value={values.complemento}
                type="text"
                maxlength={100}
                name="complemento"
                placeholder="Complemento"
                className="form-input"
                onChange={(e) => handleChange(e)}
              />
            </FormGroup>
          </S.Collunm>

          <S.Collunm className="col-4">
            <FormGroup className="form-group required">
              <label htmlFor="">Bairro</label>
              <TextField
                onBlur={handleBlur}
                value={values.bairro}
                type="text"
                maxlength={60}
                name="bairro"
                // disabled={!isCepUnico && !disableLogradouro() ? false : true}
                // disabled={checkLogradouro !== ''}
                disabled={!isCepUnico}
                error={inputErrors.bairro}
                placeholder="Bairro"
                required
                className="form-input"
                onChange={(e) => handleChange(e)}
              />
            </FormGroup>
          </S.Collunm>

          <S.Collunm className="col-6">
            <FormGroup className="form-group required">
              <label htmlFor="">Cidade</label>
              <TextField
                value={values.cidade}
                type="text"
                maxlength={60}
                name="cidade"
                disabled
                placeholder="Cidade"
                required
                className="form-input"
                onChange={(e) => handleChange(e)}
              />
            </FormGroup>
          </S.Collunm>

          <S.Collunm className="col-2">
            <FormGroup className="form-group required">
              <label htmlFor="">UF</label>
              <TextField
                value={values.uf}
                error={validateReceitaError(receitaFederalError.uf.status)}
                type="text"
                maxlength={2}
                name="uf"
                disabled
                placeholder="UF"
                required
                className="form-input"
                onChange={(e) => handleChange(e)}
              />
            </FormGroup>
          </S.Collunm>
          <S.Collunm className="col-6">
            <FormGroup className="form-group">
              <label htmlFor="">Ponto de Referência</label>
              <TextField
                onBlur={handleBlur}
                value={values.pontoReferencia}
                type="text"
                maxlength={128}
                name="pontoReferencia"
                placeholder="Ponto de Referência"
                required
                className="form-input"
                onChange={(e) => handleChange(e)}
              />
            </FormGroup>
          </S.Collunm>
        </form>
      </S.ProfileBox>
      <S.ProfileBoxFooter>
        <S.Button
          className="button button-primary"
          // type="submit"
          // form="form-endereco"
          onClick={(e) => {
            // console.log('Store', user.inscricaoEstadual)
            if (!auth.isPF()) {
              if (
                user.inscricaoEstadual !== 'ISENTO' &&
                !isInscEstValid.valid &&
                isInscEstValid.showToaster === true
              ) {
                addToast({
                  type: 'error',
                  title: capitalizePhrase(isInscEstValid.message)
                })
                // console.log(inscEstadual, isInscEstValid)
              } else {
                handleSubmit(e)
              }
            } else {
              handleSubmit(e)
            }
          }}
        >
          Salvar Endereço
        </S.Button>
        <S.Button
          className="button button-outline"
          onClick={() => setCurrent(1)}
        >
          Cancelar
        </S.Button>
      </S.ProfileBoxFooter>
    </>
  )
}

export default EditAddressForm
